<div class="container-xl">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (form()?.get('id').value) {
            <button (click)="deleteUser($event)" class="icon-button-medium" color="warn" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        }
    </div>

    @if (form()) {
        <form [formGroup]="form()" class="row gap-3" id="user-form">
            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Naam</b>
                        <div>
                            <mat-form-field class="w-100" id="name">
                                <input
                                    formControlName="name"
                                    matInput
                                    name="name"
                                    placeholder="Naam"
                                    type="text">
                                <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>E-mailadres</b>
                        <div>
                            <mat-form-field class="w-100" id="email">
                                <input
                                    formControlName="email"
                                    matInput
                                    name="email"
                                    placeholder="E-mailadres"
                                    type="email">
                                <mat-error>Vul een correct e-mailadres in</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <b>Rollen</b>
                    <div class="row">
                        <ng-select [items]="roles" [multiple]="true" [searchable]="true" bindLabel="name" bindValue="key" formControlName="roles">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <b>Tarief per uur</b>
                <div>
                    <mat-form-field class="w-100" id="hourly_rate">
                        <input
                            formControlName="hourly_rate"
                            matInput
                            name="hourly_rate"
                            placeholder="Tarief per uur"
                            step="0.01"
                            type="number">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Begin werkzaamheden</b>
                        <div>
                            <mat-form-field>
                                <input
                                    (focus)="pickerStart.open()"
                                    [matDatepicker]="pickerStart"
                                    [min]="minDate"
                                    formControlName="employment_start"
                                    matInput
                                    placeholder="Begin werkzaamheden">
                                <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerStart></mat-datepicker>
                                <mat-error [control]="form().get('employment_start')"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-auto">
                        <b>Einde werkzaamheden</b>
                        <div>
                            <mat-form-field>
                                <input
                                    (focus)="pickerEnd.open()"
                                    [matDatepicker]="pickerEnd"
                                    [min]="minDate"
                                    formControlName="employment_end"
                                    matInput
                                    placeholder="Einde werkzaamheden">
                                <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerEnd></mat-datepicker>
                                <mat-error [control]="form().get('employment_end')"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" formArrayName="assignments">
                <b>Parttime percentage per periode</b>
                @for (assignment of assignments.controls; track assignment; let i = $index) {
                    <div [formGroupName]="i" class="row align-items-start">
                        <div class="col-auto">
                            <mat-form-field>
                                <mat-label>Van</mat-label>
                                <input
                                    (focus)="pickerBegin.open()"
                                    [matDatepicker]="pickerBegin"
                                    formControlName="begin_date"
                                    matInput>
                                <mat-datepicker-toggle [for]="pickerBegin" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerBegin></mat-datepicker>
                                <mat-error [control]="assignment.get('begin_date')"></mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-auto">
                            <mat-form-field>
                                <mat-label>Tot en met (leeg = lopend)</mat-label>
                                <input
                                    (focus)="pickerEnd.open()"
                                    [matDatepicker]="pickerEnd"
                                    formControlName="end_date"
                                    matInput>
                                <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerEnd></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-auto">
                            <mat-form-field>
                                <mat-label>Percentage</mat-label>
                                <input
                                    formControlName="part_time_rate"
                                    matInput
                                    max="100"
                                    min="0"
                                    type="number">
                                <mat-error [control]="assignment.get('part_time_rate')"></mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-auto">
                            <button (click)="removeAssignment(i)" class="icon-button-medium" color="warn" mat-icon-button type="button">
                                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
                            </button>
                        </div>
                    </div>
                }
                @if (assignments.hasError('endBeforeBegin')) {
                    <div class="text-danger">Een periode kan niet eindigen voordat hij begint</div>
                }
                @if (assignments.hasError('overlap')) {
                    <div class="text-danger">De periodes mogen elkaar niet overlappen, geef de vorige periode een einddatum</div>
                }
                <div>
                    <button (click)="addAssignment()" color="primary" mat-button type="button">
                        Periode toevoegen <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Periodieke kosten</b>
                <div>
                    <mat-form-field class="w-100" id="period_costs">
                        <input
                            formControlName="period_costs"
                            matInput
                            name="period_costs"
                            placeholder="Periodieke kosten"
                            type="text">
                    </mat-form-field>
                </div>
            </div>
        </form>

        <button
            (click)="save()"
            [disabled]="form()?.invalid || saving"
            class="btn btn-primary"
            form="user-form"
            id="btn-save">
            Opslaan
            @if (saving) {
                <i class="fas fa-circle-notch fa-spin ml-2"></i>
            }
        </button>
    }
</div>
